import { debounce } from 'lodash-es';
import { A11yReadMore } from './A11yReadMore';
import { attachReferencePopup } from './popups';

export default document.addEventListener('DOMContentLoaded', () => {
  const artistsEl = document.querySelector('.artists-listing__wrapper');
  const contentEls = document.querySelectorAll('.truncate-content');

  if (artistsEl) {
    // Artist listing has a specific implemnation where read-more is _only_ applied small screen sizzes
    const artistsMql = window.matchMedia('(min-width: 36.25em)');

    // Setup read-more initially
    const artistsReadMore = new A11yReadMore({
      targetEl: artistsEl,
      maxHeight: 560,
      openText: 'Show all',
      closeText: 'Show less',
      hiddenContextText: 'artists',
    });

    window.addEventListener(
      'resize',
      debounce(() => {
        // Remove behaviour above CSS 2 column breakpoint (580)
        if (artistsMql.matches) {
          artistsReadMore.destroy();
        } else {
          artistsReadMore.setup();
        }
      }, 1000),
    );

    // For sake of DRYness just trigger the resize callback on first load
    window.dispatchEvent(new Event('resize'));
  }

  if (contentEls) {
    contentEls.forEach((contentEl) => {
      new A11yReadMore({
        targetEl: contentEl,
        maxHeight: 800,
        openText: 'Read more',
        closeText: 'Read less',
        hiddenContextText: 'content',
        afterShow: (readmore) => {
          readmore.targetEl.style.overflow = 'visible';
        },
        beforeHide: (readmore) => {
          readmore.targetEl.style.overflow = 'hidden';
        },
      });
    });

    // Need to re-attach reference popups
    const refEls = document.querySelectorAll('.reference-link');
    refEls.forEach((refEl) => {
      const target = document.querySelector(refEl.hash);
      attachReferencePopup(refEl, target);
    });
  }
});
